<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-book-alt`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M38 15a1 1 0 011-1h2a1 1 0 011 1v29a2 2 0 01-2 2H8a2 2 0 01-2-2V5a3 3 0 012.824-2.995L9 2h23a2 2 0 012 2v26H10v12h28V15zm-5 19a1 1 0 011 1v2a1 1 0 01-1 1H15a1 1 0 01-1-1v-2a1 1 0 011-1h18zM30 6H10v20h20V6z"/></svg>
</template>
<script>

export default {
  name: 'IconBookAlt',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
